import { Pagination } from '@mui/material';
import { useSearchParams } from 'react-router-dom';

type SVListPaginationProps = {
  totalRecordCount: number;
  recordsPerPage?: number;
};
export default function SVListPagination({
  totalRecordCount,
  recordsPerPage = 20,
}: SVListPaginationProps) {
  const [searchParams, setSearchParams] = useSearchParams();
  const page = searchParams.get('page') ? Number(searchParams.get('page')) : 0;
  if (totalRecordCount <= recordsPerPage) {
    return null;
  }

  const handleChange = (_event: React.ChangeEvent<unknown>, value: number) => {
    const copiedSearchParams = Object.fromEntries(searchParams.entries());
    const newSearchParams = {
      ...copiedSearchParams,
      page: `${value - 1}`,
    };
    setSearchParams(new URLSearchParams(newSearchParams));
  };

  return (
    <Pagination
      sx={{ alignSelf: 'flex-end' }}
      count={Math.ceil(totalRecordCount / recordsPerPage)}
      page={page + 1 || 1}
      defaultPage={1}
      onChange={handleChange}
    />
  );
}
